import { dataShieldStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldStarSolid = /*#__PURE__*/createIcon(dataShieldStarSolid)
export default IconShieldStarSolid
